export default __webpack_public_path__ + "static/media/logo-company-2.b114a828.png";